import { render, staticRenderFns } from "./educationResultAppr.vue?vue&type=template&id=4b8d8a88"
import script from "./educationResultAppr.vue?vue&type=script&lang=js"
export * from "./educationResultAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8d8a88')) {
      api.createRecord('4b8d8a88', component.options)
    } else {
      api.reload('4b8d8a88', component.options)
    }
    module.hot.accept("./educationResultAppr.vue?vue&type=template&id=4b8d8a88", function () {
      api.rerender('4b8d8a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/edu/educationResultAppr.vue"
export default component.exports